<template>
  <section class="Invite">
    <div class="rightLogin" v-if="state === -1">
      <div class="logo" v-if="logo">
        <img :src="logo" alt="logo">
      </div>
      <p class="name" v-if="companyName">{{companyName}}</p>
      <el-form class="Invite-form" :rules="rules" ref="ruleForm" :model="form">
        <el-form-item prop="name">
          <el-input placeholder="请输入姓名" v-model="form.name" clearable></el-input>
        </el-form-item>
        <el-form-item prop="phone">
          <el-input
            placeholder="请输入您的手机号"
            v-model="form.phone"
            @keyup.native="restrict('phone')"
            clearable
            maxlength="11"
          ></el-input>
        </el-form-item>
        <el-form-item prop="captcha" class="captcha">
          <el-input
            maxlength="6"
            v-model="form.captcha"
            @keyup.native="restrict('captcha')"
            placeholder="请输入验证码">
            <el-button
              slot="suffix"
              @click="sendSMS"
              type="text"
              class="inputSuffix"
              :loading="timeRemaining === 60 && !allow"
              :disabled="!allow">
              {{ timeRemaining === 60 ? "获取验证码" : "重新获取" + timeRemaining }}
            </el-button>
          </el-input>
        </el-form-item>
        <el-form-item style="padding-top: 6px">
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
            class="Login_Registration"
            :loading="btnLoading"
          >加入企业</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tipBox" v-if="state === 0 || state === 2">
      <div class="iconBox">
        <img src="https://static.iyw.cn/portal/H5/common/icon-f.png" alt="">
      </div>
      <div class="tip">{{ state === 0 ? '链接已失效' : '席位已满' }}</div>
      <div class="text">{{ state === 0 ? '请联系管理员重新生成邀请链接' : '请联系管理员扩充席位' }}</div>
    </div>
  </section>
  
</template>

<script>
import { phoneVerify } from "../../../tool";
import {mapActions, mapGetters} from "vuex";
import { checkLinkUrl, employeeLogin } from "@/api/accountManage";

export default {
  name: "Invite",
  data() {
    return {
      state: -2, // -2链接未校验 -1 未填 0 失效 1 成功 2 无席位
      btnLoading: false,
      pageLoading: null,
      logo: null,
      companyName: null,
      form: {
        name: "",
        phone: "",
        captcha: ""
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ validator: phoneVerify, trigger: "blur" }],
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      }
    }
  },
  computed: {
    ...mapGetters([
      "allow",
      "timeRemaining",
      "captchaKey",
      'userAgreement',
      'privacyAgreement'
    ]),
  },
  beforeCreate(){
    let isPc = function () {
      return !window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|webOS|Symbian|Windows Phone)/i);
    }();
    if(!isPc) {
      let url = process.env.VUE_APP_PORTAL_H5 + '/member/join' + window.location.href.substring(window.location.href.indexOf('?'));
      window.location.href = url;
    }
  },
  watch: {
    captchaKey(val) { // 图形验证后设置相应的 captchaKey
      this.form.captchaKey = val;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions(["getCaptcha"]),
    restrict(type) {
      if (this.form[type]) {
        this.form[type] = this.form[type].replace(
          /\D/g,
          ""
        );
      }
    },
    // 获取验证码
    async sendSMS() {
      this.$refs["ruleForm"].validateField("phone", async (err) => {
        if (!err) {
          let { data } = await this.getCaptcha({
            phone: this.form.phone,
            type: 1
          });
          if (data) {
            this.form.captchaKey = data.captchaKey;
          }
        }
      });

    },
    // 登录/注册
    async submitForm(formName) {
      let flag = true;
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          flag = false
        }
      });
      if (flag) {
        this.btnLoading = true;
        let res = await employeeLogin({
          phone: this.form.phone,
          captcha: this.form.captcha,
          captchaKey: this.form.captchaKey,
          clientType: 1, // 1设计云 2图新品 3彩虹设计网 4后台 6美术供应链
          deviceType: 1, // 1pc,2h5,3app（已取消该类型）,4小程序，5未知设备 6:android 7：ios
          userName: this.form.name,
          orgCode: this.$route.query.orgCode,
          key: this.$route.query.key,
        }).catch(() => {
          this.btnLoading = false;
        });
        if(res) {
          this.$emit("setLoginInfo", res);
          this.btnLoading = false;
        }
      }
    },
    // 账号注册
    async init() {
      this.pageLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let { code, data } = await checkLinkUrl({
        orgCode: this.$route.query.orgCode,
        key: this.$route.query.key,
      }).catch(() => {
        this.pageLoading.close();
      });
      if(code === 1) {
        this.logo = data.logo;
        this.companyName = data.companyName;
        this.state = data.checkFlag ? -1 : 0;
        if (this.state === -1 && Number(data.memberNum) <= 0) {
          this.state = 2;
        }
        this.pageLoading.close();
      } else {
        this.state = 0;
        this.pageLoading.close();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .Invite {
    .rightLogin {
      display: flex;
      flex-direction: column;
      align-items: center;
      .logo {
        width: 176px;
        height: 56px;
        overflow: hidden;
        display: flex;
        align-items: center;
        img {
          width: 100%;
        }
      }
      .name {
        margin-top: 12px;
        font-size: 16px;
        font-weight: 600;
        color: $textColor;
        line-height: 22px;
        padding: 0 46px;
        text-align: center;
      }
    }
    &-form {
      margin-top: 39px;
      .el-form-item {
        width: 284px;
        margin-bottom: 20px;
        ::v-deep.el-form-item__content {
          line-height: 46px;
          .el-input__inner {
            height: 46px;
          }
          .inputSuffix {
            line-height: 46px;
          }
        }
        .Login_Registration {
          width: 100%;
          height: 46px;
        }
      }
    }
    .tipBox {
      position: absolute;
      top: 0;
      left: 0;
      background-color: #fff;
      width: 460px;
      min-height: 528px;
      z-index: 1;
      .iconBox {
        display: flex;
        justify-content: center;
        width: 100%;
        margin-top: 186px;
        margin-bottom: 26px;
        img {
          width: 64px;
          height: 64px;
          vertical-align: middle;
        }
      }
      .tip {
        margin-bottom: 18px;
        font-size: 16px;
        font-weight: 600;
        color: #333649;
        line-height: 22px;
        text-align: center;
      }
      .text {
        font-size: 15px;
        color: #9DA1AC;
        line-height: 27px;
        text-align: center;
      }
    }
  }
</style>
<style lang="scss">
  .confirm_class {
    width: 330px!important;
    padding-bottom: 24px!important;
    .el-message-box__header {
      padding: 28px 24px 8px;
      .el-message-box__title {
        font-size: 16px;
        font-weight: 500;
        color: #333333;
      }
      .el-message-box__headerbtn {
        right: 24px;
        top: 28px;
      }
    }
    .el-message-box__content {
      padding: 10px 24px;
      .el-message-box__container {
        .el-icon-warning {
          font-size: 14px!important;
          color: #FF4040!important;
        }
        .el-message-box__message {
          padding-left: 21px;
          font-size: 14px;
          font-weight: 400;
          color: $grayColor;
        }
      }
    }
    .el-message-box__btns {
      padding: 22px 24px 0;
      .el-button {
        width: 76px;
        height: 38px;
        border-radius: 2px;
        border: 1px solid #E8E8EB;
        color: #202D40;
        &:hover {
          background-color: #FFF;
        }
      }
    }
  }
</style>